<div class="compute-to-data-panel">
  <div class="compute-to-data-panel__intro">
    <div>
      <span class="compute-to-data-panel__eyebrow">Privacy Preserving Access</span>
      <h5>Compute-to-Data Analyse</h5>
      <p>Waehlen Sie einen freigegebenen Analysejob aus. Es werden nur aggregierte Ergebnisse fuer das GU-Workspace angezeigt.</p>
    </div>

    <span class="compute-to-data-panel__badge">Keine Rohdatenuebertragung</span>
  </div>

  <div class="compute-to-data-panel__controls">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Algorithmus</mat-label>
      <mat-select [(value)]="selectedAlgorithm" [disabled]="isRunning">
        <mat-option value="delay-risk">Verzoegerungs-Risiko-Analyse v2.1</mat-option>
        <mat-option value="cost-estimate">Kosten-Trend-Analyse v1.0</mat-option>
        <mat-option value="quality-signal">Qualitaets-Signal Check v0.9</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-raised-button color="primary" class="compute-to-data-panel__run" (click)="runAnalysis()" [disabled]="isRunning">
      <mat-icon>{{ isRunning ? 'hourglass_top' : 'play_arrow' }}</mat-icon>
      {{ isRunning ? 'Processing laeuft...' : 'Processing starten' }}
    </button>
  </div>

  <div class="compute-to-data-panel__status" *ngIf="isRunning || showResult">
    <mat-divider></mat-divider>

    <div class="deployment-status" *ngIf="isRunning">
      <mat-spinner diameter="28"></mat-spinner>
      <div>
        <strong>Analyse wird verarbeitet</strong>
        <span>{{ processingLabel }}</span>
      </div>
    </div>

    <div class="result-widget" *ngIf="showResult">
      <div class="result-widget__header">
        <div>
          <strong>Analyse-Ergebnis</strong>
          <p>Ausgabe des freigegebenen Compute-to-Data Jobs</p>
        </div>
        <span class="confidential-tag">Aggregiert</span>
      </div>

      <div class="result-widget__body">
        <div class="score-display">
          <span class="score-value">82%</span>
          <span class="score-label">Wahrscheinlichkeit fuer Zeitverzug</span>
        </div>

        <div class="result-insights">
          <div class="result-insight">
            <strong>Hoher Einfluss</strong>
            <span>Witterung + reduzierte Mannschaft in 3 Berichten</span>
          </div>
          <div class="result-insight">
            <strong>Datengrundlage</strong>
            <span>45 analysierte Tagesberichte, 0 exportierte Rohdaten</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
